import type { CSSProperties } from 'react';
import { Toaster } from 'sonner';
import { useTheme } from '@/hooks/useTheme';

/**
 * Sonner hardcodes `--border-radius: 8px` on its own container, which made a
 * toast the one panel on screen that disagreed with every other panel.
 *
 * Set here rather than in `styles/vendor.css` because sonner injects its
 * stylesheet at runtime, so it lands after that file and wins on source order
 * at equal specificity — the same cascade trap the MapLibre overrides had to
 * double their class names to get out of. An inline style is above all of it
 * and sits next to the rest of the toaster's configuration.
 */
const RADIUS = { '--border-radius': 'var(--radius)' } as CSSProperties;

export function ThemedToaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Toaster position="top-right" theme={resolvedTheme} richColors closeButton style={RADIUS} />
  );
}
